import React from 'react';
import classnames from 'classnames';
import { cmxRuntime } from '@codametrix/ui-common';
import { registerVisibilityListener } from './page-visibility';

type AppShellProps = {
  registerActivity?: () => void;
} & React.HTMLAttributes<HTMLDivElement>;

const DEFAULT_PROPS = {
  registerActivity: () => {}
};

registerVisibilityListener(document);

const AppShell = (props: AppShellProps) => {
  const allProps = { ...DEFAULT_PROPS, ...props };
  const { children, registerActivity, className, ...spreadable } = allProps;

  const classNames = classnames([
    className,
    `cmx-app`,
    'cmx-application-masked',
    'cmx-application-loading',
    // calling this cmx-application-chakra had side effects
    { 'cmx-application-new-design': cmxRuntime.runtimeOverrides?.newAdminDesign }
  ]);

  return (
    <div
      {...spreadable}
      className={classNames}
      onMouseDown={registerActivity}
      onKeyPress={registerActivity}>
      <div className="layout-main">
        <main className="content-container max-dimensions">{children}</main>
      </div>
    </div>
  );
};

export { AppShell };
